import { render, staticRenderFns } from "./PasswordChangeOldRequired.vue?vue&type=template&id=b0c593da&scoped=true"
import script from "./PasswordChangeOldRequired.vue?vue&type=script&lang=js"
export * from "./PasswordChangeOldRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c593da",
  null
  
)

export default component.exports